<!--
 * @Author: your name
 * @Date: 2021-09-14 14:23:52
 * @LastEditTime: 2022-03-19 10:13:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\review\children\ProgramMaterial.vue
-->
<template>
  <el-table :data="wicketList" style="width: 100%" height="100%">
    <el-table-column :label="$t('review.Name')" show-overflow-tooltip>
      <template slot-scope="scope">{{scope.row.ext_val_name || scope.row.field_cn}}</template>
    </el-table-column>
    <el-table-column prop="name" :label="$t('review.Resolution')">
      <template slot-scope="scope">{{scope.row.ext_val_resolution || '--'}}</template>
    </el-table-column>
    <el-table-column :label="$t('review.Size')">
      <template slot-scope="scope">{{formatType(scope.row)}}</template>
    </el-table-column>
    <el-table-column :label="$t('review.Preview')" width="80">
      <template slot-scope="scope">
        <div class="flex-c-c" v-if="scope.row.type === '1' || scope.row.type === '2'">
          <img class="icon" src="@imgpub/public_preview.png" @click="handlePreview(scope.$index, scope.row)" alt />
        </div>
        <span v-else>--</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js'
import { dataFlattening } from '@/assets/scripts/programData.js'
import { hexToRgba } from '@/assets/scripts/rgbaAndHex.js'
import toolsList from '@/assets/scripts/toolsList.js';
export default {
  name: "ProgramMaterial",
  props: {
    vdrList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      wicketList: [],
      toolsList: toolsList(),
    }
  },
  methods: {
    handlePreview(index, row) {
      this.$emit("handlePreview", index, { type: row.type, ref_url: row.field_item_path });
    },
    vdrInit(vdrList) {
      this.wicketList = [];
      vdrList.forEach((vdrItem) => {
        vdrItem.wicket.forEach((wicketItem) => {
          this.wicketList.push(this.wicketInit(dataFlattening(wicketItem)))
        });
      });
    },
    // 数据解析
    wicketInit(wicket) {
      // 初始化播放时长
      wicket.ext_val_duration = parseInt(wicket.ext_val_duration / 1000);
      // 进入时间初始化
      if (wicket.ext_val_enterTime !== undefined) {
        wicket.ext_val_enterTime = parseInt(wicket.ext_val_enterTime / 1000);
      }
      // 时间格式化
      if (wicket.type === '12' || wicket.type === '13') {
        wicket.ext_val_absoluteTime = new Date(wicket.ext_val_absoluteTime * 1000);
      }
      // 初始化颜色设置
      for (let key in wicket) {
        if (/Color?$/.test(key)) {
          wicket[key] = hexToRgba(wicket[key]);
        }
      }
      // 保持比例格式化
      if (wicket.ext_val_scaleType !== undefined) {
        wicket.ext_val_scaleType = wicket.ext_val_scaleType === 1 ? false : true;
      }
      // 初始化工具图标
      let isUpPimg = { '1': true, '2': true }
      if (!isUpPimg[wicket.type]) {
        let tool = this.toolsList.find((tool) => tool.type === wicket.type);
        wicket.ext_val_pimg = tool.image;
      }
      // console.log(wicket);
      return wicket;
    },
    formatType(row) {
      let refSize = (parseInt(row.ext_val_size) / 1024).toFixed(1);
      let refSizeMB = refSize / 1024;
      if (refSizeMB < 1) {
        refSize = (refSizeMB * 1024).toFixed(1) + "KB";
      } else if (refSizeMB >= 1 && refSizeMB < 1024) {
        refSize = refSizeMB.toFixed(1) + "MB";
      } else if (refSizeMB >= 1024) {
        refSize = (refSizeMB / 1024).toFixed(1) + "GB";
      }
      switch (row.type.toString()) {
        case "1": return `${this.$t('crcp1')}(${refSize})`;
        case "2": return `${this.$t('crcp2')}(${refSize})`;
        // case "6": return `mp3(${refSize})`;
        // case "10": return `文本(${refSize})`;
        default: return `--`;
      }
    },
  },
  watch: {
    vdrList: {
      handler(nVal) {
        this.$nextTick(() => {
          this.vdrInit(superClone(nVal));
        });
      },
      immediate: true
    }
  }
}
</script>


<style lang="scss" scoped>
.icon {
  width: 30px;
  height: 30px;
  margin-right: 25px;
}
</style>